import { VerticalMenuIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function SRVTableActionsMenuButton(props) {
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, props, {
    use: "link",
    children: /*#__PURE__*/_jsx(VerticalMenuIcon, {})
  }));
}